import {fetch} from "utils/dataAccess";
import {ShipmentStatus} from "../../../utils/ShipmentStatus";
import {LineItemStatus} from "../../../utils/LineItemStatus";

export function shipmentPacked(shipmentId) {
    return new Promise((resolve, reject) => {
        fetch("/shipments/packed/"+shipmentId)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}

export function resetCurrentPacking(shipmentId) {
    return new Promise((resolve, reject) => {
        fetch("shipments/resetPacking/"+shipmentId)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}

export function shipmentSorted(shipmentId) {
    return new Promise((resolve, reject) => {
        fetch("/shipments/sorted/"+shipmentId, {}, false, true)
            .then(response=> {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}

export function getShipmentInCCTransit(currentInventory, page = 1) {
    return new Promise((resolve, reject) => {
        fetch(`/shipments?inventoryId=${currentInventory.id}&status=${ShipmentStatus.CC_TRANSIT}&page=${page}`)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}

export async function getShipmentByExternalDeliveryNumber(externalDeliveryNumber, currentInventory) {
    const response = await fetch(`/shipments?externalDeliveryNumber=${externalDeliveryNumber}&inventoryId=${currentInventory.id}`)

    const res = await response.json();

    return res['hydra:member'];
}

export function getShipmentInReturn(currentInventory, hasReturnRequestFeature = true, page = 1) {
    let params = `inventoryId=${currentInventory.id}&lineItemStatus=[${LineItemStatus.RETURNING_RUNNER},${LineItemStatus.RETURNING_RETAILER}]&group[]=wms_shipment:read&group[]=translations&page=${page}`;

    if (hasReturnRequestFeature) {
        params = `${params}&exists[return]=true`
    }

    return new Promise((resolve, reject) => {
        fetch(`/shipments?${params}`)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}

export function setShipmentsInInventory(shipmentId, currentInventoryId) {
    return new Promise((resolve, reject) => {
        fetch(`/shipments/${shipmentId}/putInInventory`, {
            method: 'PATCH',
            headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
            body: JSON.stringify({
                inventoryId: currentInventoryId,
            }),
        })
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved["hydra:member"])
                })
            })
            .catch(error => reject(error))
    })
}

export function assignShipmentToContainer(containerCodeBar, shipmentId) {
    return new Promise((resolve, reject) => {
        fetch("/shipments/"+shipmentId, {
            method: "PATCH",
            headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
            body: JSON.stringify({
                container: "/w_m_s_containers/" + containerCodeBar
            })
        }, false, true)
            .then((response) => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}
